module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Detalhe"},"en-US":{"title":"Detail"}}')
  delete Component.options._Ctor
}
